import styled from 'styled-components';
import { HIDDEN_PRINT } from './constants';

const PrintHiddenDiv = styled.div`
    ${HIDDEN_PRINT}
`;

export default PrintHiddenDiv;
